import styled from "styled-components";
import { Card } from "components/common";

export const Wrapper = styled(Card)`
  margin-bottom: 10px;
  .ant-card-body {
    border: 2px solid #bfb5b5;
    border-radius: 5px;
  }
  .name {
    font-size: 20px;
    text-align: center;
    font-weight: bold;
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    h6 {
      color: #6e6262d9;
      font-size: 10px;
    }
    h5 {
      font-size: 13px;
    }
  }
  .image-container {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
  }
  .image {
    border-radius: 50%;
    width: 60px;
    height: 60px;
    background: none;
  }
  .edit-button {
    color: #3a96b8;
    background: transparent;
    border: 1px solid #3a96b8;
    :hover {
      background: #3a96b8;
      color: #ffffff;
      border: 1px solid white;
    }
  }
  .action-bar{
    display: flex;
    justify-content: center;
  }
`;
